// Words for the games, levels A1 and A2.
// Each word is written once in all five languages, in this order: English, Italian, Spanish, French, Portuguese (Brazil).
// Single words only, so they also work in the word search grid.

export const GAME_WORDS_A = {
    A1: [
        ['water', 'acqua', 'agua', 'eau', 'água'],
        ['bread', 'pane', 'pan', 'pain', 'pão'],
        ['house', 'casa', 'casa', 'maison', 'casa'],
        ['friend', 'amico', 'amigo', 'ami', 'amigo'],
        ['cat', 'gatto', 'gato', 'chat', 'gato'],
        ['dog', 'cane', 'perro', 'chien', 'cachorro'],
        ['sun', 'sole', 'sol', 'soleil', 'sol'],
        ['moon', 'luna', 'luna', 'lune', 'lua'],
        ['sea', 'mare', 'mar', 'mer', 'mar'],
        ['book', 'libro', 'libro', 'livre', 'livro'],
        ['milk', 'latte', 'leche', 'lait', 'leite'],
        ['apple', 'mela', 'manzana', 'pomme', 'maçã'],
        ['coffee', 'caffè', 'café', 'café', 'café'],
        ['tea', 'tè', 'té', 'thé', 'chá'],
        ['wine', 'vino', 'vino', 'vin', 'vinho'],
        ['salt', 'sale', 'sal', 'sel', 'sal'],
        ['sugar', 'zucchero', 'azúcar', 'sucre', 'açúcar'],
        ['mother', 'madre', 'madre', 'mère', 'mãe'],
        ['father', 'padre', 'padre', 'père', 'pai'],
        ['brother', 'fratello', 'hermano', 'frère', 'irmão'],
        ['family', 'famiglia', 'familia', 'famille', 'família'],
        ['child', 'bambino', 'niño', 'enfant', 'criança'],
        ['day', 'giorno', 'día', 'jour', 'dia'],
        ['night', 'notte', 'noche', 'nuit', 'noite'],
        ['morning', 'mattina', 'mañana', 'matin', 'manhã'],
        ['red', 'rosso', 'rojo', 'rouge', 'vermelho'],
        ['blue', 'blu', 'azul', 'bleu', 'azul'],
        ['green', 'verde', 'verde', 'vert', 'verde'],
        ['white', 'bianco', 'blanco', 'blanc', 'branco'],
        ['black', 'nero', 'negro', 'noir', 'preto'],
        ['table', 'tavolo', 'mesa', 'table', 'mesa'],
        ['chair', 'sedia', 'silla', 'chaise', 'cadeira'],
        ['door', 'porta', 'puerta', 'porte', 'porta'],
        ['window', 'finestra', 'ventana', 'fenêtre', 'janela'],
        ['hand', 'mano', 'mano', 'main', 'mão'],
        ['nose', 'naso', 'nariz', 'nez', 'nariz'],
        ['mouth', 'bocca', 'boca', 'bouche', 'boca'],
        ['tree', 'albero', 'árbol', 'arbre', 'árvore'],
        ['flower', 'fiore', 'flor', 'fleur', 'flor'],
        ['fish', 'pesce', 'pez', 'poisson', 'peixe'],
        ['rain', 'pioggia', 'lluvia', 'pluie', 'chuva'],
    ],
    A2: [
        ['city', 'città', 'ciudad', 'ville', 'cidade'],
        ['work', 'lavoro', 'trabajo', 'travail', 'trabalho'],
        ['school', 'scuola', 'escuela', 'école', 'escola'],
        ['train', 'treno', 'tren', 'train', 'trem'],
        ['street', 'strada', 'calle', 'rue', 'rua'],
        ['shop', 'negozio', 'tienda', 'magasin', 'loja'],
        ['week', 'settimana', 'semana', 'semaine', 'semana'],
        ['month', 'mese', 'mes', 'mois', 'mês'],
        ['kitchen', 'cucina', 'cocina', 'cuisine', 'cozinha'],
        ['garden', 'giardino', 'jardín', 'jardin', 'jardim'],
        ['bicycle', 'bicicletta', 'bicicleta', 'vélo', 'bicicleta'],
        ['airplane', 'aereo', 'avión', 'avion', 'avião'],
        ['hospital', 'ospedale', 'hospital', 'hôpital', 'hospital'],
        ['bank', 'banca', 'banco', 'banque', 'banco'],
        ['money', 'soldi', 'dinero', 'argent', 'dinheiro'],
        ['price', 'prezzo', 'precio', 'prix', 'preço'],
        ['doctor', 'medico', 'médico', 'médecin', 'médico'],
        ['weather', 'tempo', 'tiempo', 'temps', 'clima'],
        ['winter', 'inverno', 'invierno', 'hiver', 'inverno'],
        ['summer', 'estate', 'verano', 'été', 'verão'],
        ['spring', 'primavera', 'primavera', 'printemps', 'primavera'],
        ['autumn', 'autunno', 'otoño', 'automne', 'outono'],
        ['sky', 'cielo', 'cielo', 'ciel', 'céu'],
        ['mountain', 'montagna', 'montaña', 'montagne', 'montanha'],
        ['river', 'fiume', 'río', 'fleuve', 'rio'],
        ['shirt', 'camicia', 'camisa', 'chemise', 'camisa'],
        ['shoes', 'scarpe', 'zapatos', 'chaussures', 'sapatos'],
        ['telephone', 'telefono', 'teléfono', 'téléphone', 'telefone'],
        ['music', 'musica', 'música', 'musique', 'música'],
        ['game', 'gioco', 'juego', 'jeu', 'jogo'],
    ],
};